import { Pipe, PipeTransform } from '@angular/core';
import { InstallationPreparationNeededPluginService } from './preparation-needed.service';

@Pipe({
    name: 'preparation',
    standalone: false
})
export class InstallationPreparationPipe implements PipeTransform {
  public preparations: any[];

  constructor(private service: InstallationPreparationNeededPluginService) {
    this.preparations = this.service.getPreparations();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.preparations);
  }
}
